import { render, staticRenderFns } from "./weekStarRule.vue?vue&type=template&id=adf87e90&scoped=true&"
import script from "./weekStarRule.vue?vue&type=script&lang=js&"
export * from "./weekStarRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf87e90",
  null
  
)

export default component.exports